import React from "react";
import { Redirect, Route } from "react-router-dom";
import { isAuthenticated } from "../../../../service/auth";
import { hasRoleAccess } from "../../../../service/authorization";

const AdminRoute = ({
    component: Component,
    allowedRoles = [],
    requireReadOnlyProduct = false,
    ...rest
}) => (
    <Route
        {...rest}
        render={(props) => {
            if (!isAuthenticated()) {
                return (
                    <Redirect
                        to={{ pathname: "/ctop", state: { from: props.location } }}
                    />
                );
            }

            if (allowedRoles.length > 0 && !hasRoleAccess(allowedRoles)) {
                return (
                    <Redirect
                        to={{
                            pathname: "/ctop/forbidden",
                            state: { from: props.location },
                        }}
                    />
                );
            }

            return (
                <Component
                    {...props}
                    requireReadOnlyProduct={requireReadOnlyProduct}
                />
            );
        }}
    />
);

export default AdminRoute;
